// extracted by mini-css-extract-plugin
export var drawerContent = "_2t-0";
export var valueBlock = "_2t-1";
export var valueBlockFrom = "_2t-2 _2t-1";
export var valueBlockTo = "_2t-3 _2t-1";